// DS: C37
/** Container used to display a deviation using the entire page width */ import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import DesktopArtStage from './DesktopArtStage';
import DesktopTextualArtStage from './DesktopTextualArtStage';
import CommissionMobileArtStage from './CommissionMobileArtStage';
import MobileArtStage from './MobileArtStage';
import CommissionStage from './CommissionStage';
import SimpleStage from './_partials/SimpleStage';
const ArtStage = ({ deviation, isOwner, className, isZoomed, onEnterZoomMode, onExitZoomMode })=>{
    const isMobile = useContext(MobileContext);
    const deviationType = getDeviationType(deviation);
    if (isMobile) {
        return deviationType === DeviationTypes.COMMISSION ? /*#__PURE__*/ React.createElement(CommissionMobileArtStage, {
            deviation: deviation,
            className: className
        }) : /*#__PURE__*/ React.createElement(MobileArtStage, {
            deviation: deviation,
            className: className,
            isZoomed: isZoomed,
            onEnterZoomMode: ()=>onEnterZoomMode(deviation),
            onExitZoomMode: ()=>onExitZoomMode(deviation)
        });
    }
    switch(getDeviationType(deviation)){
        case DeviationTypes.POLL:
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(SimpleStage, {
                deviation: deviation
            });
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionStage, {
                deviation: deviation
            });
        case DeviationTypes.TIER:
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(DesktopTextualArtStage, {
                deviation: deviation,
                className: className
            });
        default:
            return /*#__PURE__*/ React.createElement(DesktopArtStage, {
                deviation: deviation,
                isOwner: isOwner,
                className: className,
                isZoomed: isZoomed,
                onEnterZoomMode: ()=>onEnterZoomMode(deviation),
                onExitZoomMode: ()=>onExitZoomMode(deviation)
            });
    }
};
ArtStage.displayName = 'ArtStage';
export default ArtStage;

//# sourceMappingURL=ArtStage.js.map